/* eslint-disable @typescript-eslint/no-explicit-any */
import {Font} from '@react-pdf/renderer';
import React from 'react';
import {RegisterArial} from '../../../ressources/fonts/arial/arial_font';
import {CpCgRCVP} from './rcvp/cpcgRcvp';
import {CpCgRetraite} from './retraite/cpcgRetraite';
import {CpCgScolaire} from './scolaire/cpcgScolaire';
import {CpCgVoyage} from './voyage/cpcgVoyage';

export const RegisterFonts = () => {
  RegisterArial();
  Font.register({
    family: 'Open Sans',
    fonts: [
      {
        src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf',
      },
      {
        src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf',
        fontWeight: 800,
      },
    ],
  });
  
  // Define a custom font with a bold style
  Font.register({
    family: 'Roboto',
    fonts: [
      {src: 'https://fonts.cdnfonts.com/s/12165/Roboto-Regular.woff'},
      {
        src: 'https://fonts.cdnfonts.com/s/12165/Roboto-Thin.woff',
        fontWeight: 250,
      },
      {
        src: 'https://fonts.cdnfonts.com/s/12165/Roboto-Light.woff',
        fontWeight: 300,
      },
      {
        src: 'https://fonts.cdnfonts.com/s/12165/Roboto-Medium.woff',
        fontWeight: 500,
      },
      {
        src: 'https://fonts.cdnfonts.com/s/12165/Roboto-Black.woff',
        fontWeight: 900,
      },
    ],
  });
};

// Create Document Component
export const MonAttestation = (props: any) => {
  const {detailContrat} = props;

  const GetInfoContractByType = () => {
    const {typeContrat} = detailContrat;
    if (typeContrat == 'scolaire') {
      return <CpCgScolaire detailContrat={detailContrat} />;
    } else if (typeContrat == 'retraite') {
      return <CpCgRetraite detailContrat={detailContrat} />;
    } else if (typeContrat == 'voyage') {
      return <CpCgVoyage detailContrat={detailContrat} />;
    } else {
      return <CpCgRCVP detailContrat={detailContrat} />;
    }
  };
  return <GetInfoContractByType />;
};
